import { isRoleAdmin, hasRoleRisk } from './roles';
import { RoleInput } from '../schemas';

export const canEditCreditLine = (roles: RoleInput[] = []) => hasRoleRisk(roles) || isRoleAdmin(roles);
